import React from "react";
import { FiMapPin } from "react-icons/fi";
import Logo from "../styles/Black-SVG-Landscape.svg";
import JuanEstebanPhoto from "../candidates/tomas.jpg"

export default function SocialMediaCreativeStrategistTomas() {
  const candidateProfileCopy = {
    name: "Tomas",
    location: "Colombia",
    compensation: {
      range: "$17 USD / hourly",
    },
    availability: "Available to start immediately",
 
    working_style:
      "Tomas is a systems-oriented digital strategist who operates at the intersection of content strategy and AI automation. He builds content ecosystems using tools like n8n, Claude, ChatGPT, and Gemini, including editorial calendars, automated pipelines, and multi-format publishing workflows. He brings strong B2B marketing experience, neuromarketing frameworks, and CRM lifecycle management to his content thinking. His natural output leans toward written and strategic content (white papers, case studies, thought leadership, email sequences) and he is the most AI-sophisticated candidate in this group by a significant margin.",
 
    loom_video_link: "https://fathom.video/share/BCMNsy24RLAg3L5Go8G3nyXg187j4XkR",
 
    tools: [
      {
        category: "AI & Automation",
        items: [
          "n8n workflow automation integrated with foundational AI models for scaled content production",
          "Claude, ChatGPT, Gemini, Google AI Studio (professional-level multi-model usage)",
          "AI-first operational framework deployed across agency operations",
          "Automated content ecosystems for market research, competitor analysis, and multi-format generation",
        ],
      },
      {
        category: "Content Strategy & Publishing",
        items: [
          "Editorial calendar management and content pillar architecture",
          "LinkedIn, Facebook, Instagram (multi-channel social media management)",
          "Framer and Shopify (full-stack web architecture and e-commerce)",
          "SEO optimization and analytics-driven content planning",
          "HubSpot and Salesforce (CRM lifecycle management and lead nurture)",
        ],
      },
      {
        category: "Copywriting & Sales Enablement",
        items: [
          "White papers, case studies, and thought leadership articles",
          "Email sequences, sales battle cards, and pitch scripts for complex buyer journeys",
          "UGC scripting and hook concepts (broker/financial services context)",
          "Technical copywriting translating complex data into actionable communications",
        ],
      },
      {
        category: "Operations & Project Management",
        items: [
          "Agency co-founding and cross-functional leadership (BeOne Hub)",
          "B2B client portfolio management in the U.S. market",
          "Data management across TMS and CRM platforms",
          "Google Workspace and project coordination tools",
        ],
      },
    ],
 
    soft_skills: [
      "Most advanced AI and automation capability in this candidate group. Builds systems, not just uses tools",
      "Strong strategic intelligence: thinks in content architectures, editorial systems, and lifecycle frameworks",
      "Entrepreneurial ownership: co-founded and scaled a B2B marketing agency",
      "Bilingual (English/Spanish) with demonstrated U.S. client-facing professional experience",
      "Articulate communicator with organized, structured thinking",
      "Self-directed and comfortable with ambiguity in startup-stage environments",
    ],
 
    about_candidate:
      "Tomas is an intelligent, articulate professional with genuine strengths in B2B content strategy, AI automation workflows, and technical copywriting. He co-founded BeOne Hub, a strategic B2B marketing agency, and built AI-powered content ecosystems using n8n and foundational models. He has managed B2B client portfolios in the U.S. market, authored English-language case studies and white papers, and implemented an AI-first operational framework across his agency. His strategic intelligence and automation sophistication are real. Most of his experience to date has been in B2B and SaaS environments, so the DTC social content production side of this role (short-form video, graphic design, platform-native content for TikTok and Instagram) would be a newer area for him, though his AI capabilities and systems thinking could help him adapt.",
 
    core_strengths: [
      {
        headline: "Most advanced AI and automation capability in this group",
        description:
          "Built automated content ecosystems using n8n integrated with foundational AI models. Implemented an AI-first operational framework across his agency. Uses Claude, ChatGPT, Gemini, and Google AI Studio at a workflow-architecture level. His AI sophistication goes beyond tool usage into system design and process automation, which is a capability none of the other candidates bring to the table.",
      },
      {
        headline: "Strong strategic intelligence and structured systems thinking",
        description:
          "Thinks in content architectures, editorial calendars, content pillars, and lifecycle frameworks. His B2B content strategy experience with lead generation workflows, CRM management, and sales enablement demonstrates real strategic capability and structured problem-solving that could translate well to building content systems from scratch.",
      },
      {
        headline: "Entrepreneurial ownership with agency co-founding experience",
        description:
          "Co-founded BeOne Hub and built a B2B marketing agency using lean methodology. Acted as cross-functional lead owning both business strategy and client delivery. This kind of self-direction and comfort with ambiguity is exactly what a ground-floor role like this one calls for.",
      },
      {
        headline: "Bilingual professional with U.S. market client experience",
        description:
          "Has managed B2B client portfolios in the U.S., authored English-language case studies and thought leadership, and operated in cross-cultural business environments. His English communication is strong and has been tested in professional, client-facing settings.",
      },
    ],
 
    relevant_experience: [
      {
        headline: "AI Content Strategist & Digital Architect | Independent Practice | January 2023 to Present",
        bullets: [
          "End-to-end digital strategy for U.S.-based B2B clients: website architecture, SEO, copywriting, and social media content",
          "Engineered automated content ecosystems integrating n8n and AI models to scale production while maintaining brand voice",
          "Authored case studies, white papers, and thought leadership articles for brand authority and sales enablement",
          "Designed high-converting email sequences, sales battle cards, and pitch scripts for complex buyer journeys",
        ],
      },
      {
        headline: "Co-Founder & Operations Director | BeOne Hub | June 2024 to January 2026",
        bullets: [
          "Co-founded and scaled a strategic B2B marketing agency using lean, SaaS-oriented startup methodology",
          "Developed content pillars and managed editorial calendars for brand awareness and lead generation across LinkedIn, Facebook, and Instagram",
          "Implemented an AI-first operational framework using automated agents for research, competitor analysis, and content generation",
        ],
      },
      {
        headline: "Operational Specialist | USA TruckBrokers | February 2023 to September 2023",
        bullets: [
          "Managed complex B2B communications between U.S. brokers and customers with operational alignment",
          "Executed data management and bid filtering across TMS and load board platforms",
        ],
      },
      {
        headline: "Operations Support Accelerator | Hubtek | August 2022 to February 2023",
        bullets: [
          "Facilitated B2B communications in U.S. logistics, ensuring real-time tracking in a high-volume environment",
          "Platform and data management driving operational efficiency and process optimization",
        ],
      },
    ],
  };
 
  const technicalAssessment = {
    meta: {
      role: "Social Media Creative Strategist, Frizo / LGO Brands",
      interviewDate: "March 16, 2026",
      analyst: "AI-Architechs Senior Technical Hiring Analysis",
    },
 
    snapshot:
      "Tomas is an intelligent professional with genuine strengths in B2B content strategy, AI automation workflows, and technical copywriting. He co-founded a marketing agency, built AI-powered content ecosystems, and has managed B2B client portfolios in the U.S. market. His AI and automation skills are the strongest in this candidate group by a clear margin. Most of his experience has been in B2B and SaaS environments, so the DTC social content production side of this role would be a newer area for him. He brings real strategic depth and the kind of systems thinking that becomes increasingly valuable as a content operation scales.",
 
    scorecard: [
      {
        dimension: "Content Production & Visual Identity",
        score: 3,
        rationale:
          "Tomas's production background is rooted in written content like case studies, white papers, email sequences, and sales enablement copy rather than visual-first social media production. His CV doesn't list dedicated video editing or graphic design tools like CapCut, Premiere, Canva, or Adobe, and his strongest contributions sit on the strategy and automation side. For the visual content production layer of this role, his capability is unverified, though his AI toolchain and systems thinking could accelerate his learning curve here.",
      },
      {
        dimension: "Content-to-Subscriber Pipeline Thinking",
        score: 6,
        rationale:
          "He understands the goal of moving viewers to email subscribers and described CTAs directing to forms and websites for email capture. He also references email sequences and nurture campaigns from his B2B work. His pipeline thinking is real but comes from a B2B context (lead capture into CRM into sales enablement) rather than DTC (content into subscriber into email sales). The mechanics transfer, though the specific execution would look different in this role.",
      },
      {
        dimension: "Full-Funnel Content Strategy",
        score: 6,
        rationale:
          "Referenced discovery, nurture, and close-deal phases that map to the three funnel layers. Discussed content pillars based on products and target customers. His funnel thinking is structured and systematic, though it's expressed through B2B and neuromarketing language rather than the DTC content vocabulary this role uses day to day. The underlying logic is sound and would need some translation into the DTC context.",
      },
      {
        dimension: "Scripting, Hook Writing & Copywriting",
        score: 5,
        rationale:
          "Has solid copywriting experience with email sequences, sales battle cards, pitch scripts, and case studies. Described UGC scripting for a broker client with creative hook examples including humor and attention-grabbing openings. His copywriting skills are real, though his examples came from financial services and crypto contexts rather than DTC product brands. He'd be adapting a strong writing foundation to a new content style.",
      },
      {
        dimension: "Founder Coaching & On-Camera Direction",
        score: 6,
        rationale:
          "Asked a smart clarifying question about whether the founder would be the face of the brand, and talked about assessing the founder's personality to adapt video formats accordingly. He has some experience directing UGC creators for video content. He also suggested bringing in UGC creators alongside the founder, which shows he's thinking about how to maximize content variety, though the role's primary focus is on developing Chad as the on-camera talent.",
      },
      {
        dimension: "Competitive Research & Cross-Category Intelligence",
        score: 6,
        rationale:
          "Described analyzing competitor social metrics to understand what's working and why. Mentioned using Claude for narrative research and Perplexity for competitive intelligence, which shows he brings AI tools into his research process. His approach is logical and tool-informed, though he described it at a higher level than some candidates who walked through more specific tracking systems.",
      },
      {
        dimension: "Metrics Accountability & Performance Optimization",
        score: 5,
        rationale:
          "Identified engagement rate and email conversion as the most important metrics for this type of role. His optimization approach, changing strategy based on competitive analysis and audience feedback, is logical. He didn't reference specific before/after metrics from his own work in this interview, which makes it harder to assess his track record of moving numbers. The metric-driven feedback loop that defines this role is something he'd be building into his workflow rather than bringing from previous experience.",
      },
      {
        dimension: "Regulated/Restricted-Ad Industry Readiness",
        score: 4,
        rationale:
          "No direct experience in restricted-ad industries yet. He acknowledged he'd need to study platform limitations for each product type and each platform, and suggested using simplified language for top-of-funnel educational content. His approach was thoughtful and his willingness to learn was clear, though he'd be starting from scratch on the compliance and platform restriction knowledge that this industry requires.",
      },
      {
        dimension: "AI Tools & Workflow Efficiency",
        score: 9,
        rationale:
          "The strongest AI profile in this candidate group by a significant margin. He's built automated content ecosystems using n8n and foundational AI models, uses Claude, ChatGPT, Gemini, and Google AI Studio at a professional workflow-architecture level, and implemented an AI-first operational framework across his agency. His sophistication goes well beyond tool usage into system design, agent architecture, and process automation. This is a genuinely differentiating capability.",
      },
    ],
 
    strengths: [
      {
        headline: "Most advanced AI and automation capability in this candidate group",
        description:
          "His n8n workflow automation, AI-first operational framework, and multi-model toolchain represent genuine technical depth that none of the other candidates bring. He builds automated content systems rather than just using AI features. As the content operation grows and the need for automated workflows increases, this skillset becomes increasingly valuable.",
      },
      {
        headline: "Strong strategic intelligence with structured systems thinking",
        description:
          "Articulate, organized, and systematic in his approach to content architecture. His B2B strategy experience with editorial calendars, content pillars, lead generation workflows, and CRM lifecycle management demonstrates real strategic capability. This kind of structured thinking translates well to building content systems from the ground up, even in a new industry context.",
      },
      {
        headline: "Entrepreneurial ownership and agency co-founding experience",
        description:
          "Co-founded BeOne Hub and built a B2B marketing agency from scratch, demonstrating self-direction, strategic ownership, and comfort operating in ambiguity. He thinks and operates like a partner, not a task-executor, which is the kind of ownership mindset this role calls for.",
      },
      {
        headline: "Bilingual professional with proven U.S. market experience",
        description:
          "Has managed B2B client portfolios in the U.S., authored English-language case studies and white papers, and operated in cross-cultural business environments. His English communication is strong, structured, and has been tested in professional client-facing settings.",
      },
    ],
 
    flags: [
      {
        headline: "DTC social content production would be a new area",
        description:
          "Most of Tomas's content experience has been in B2B environments, producing written content like case studies, white papers, and email sequences. The daily production work this role requires (editing TikToks, designing carousels, creating Instagram Reels, producing product imagery) would be a transition for him. His AI tools and systems thinking could help him adapt, but it's worth understanding how he'd approach that learning curve in conversation.",
      },
      {
        headline: "B2B background means some translation is needed for DTC",
        description:
          "The role is built around physical product brand content for consumer audiences on TikTok, Instagram, and YouTube Shorts. Tomas's experience is in B2B service-brand content across LinkedIn, websites, and sales enablement. The content formats, platform behaviors, and audience psychology are different enough that there would be an adaptation period as he transitions his strategic skills into the DTC context.",
      },
      {
        headline: "Metric-specific vocabulary is still developing for this context",
        description:
          "He identified the right types of metrics (engagement, conversion) as important but wasn't yet fluent in the specific metric framework this role is built around. This isn't a fundamental gap in his analytical capability, but it does suggest the three-metric accountability system (subscriber conversion, engagement rate, follower growth) would be something he's learning on the job rather than bringing from day one.",
      },
    ],
 
    when_to_hire: [
      "The role scope grows to include content automation architecture, AI workflow design, or strategic content systems alongside DTC social production.",
      "The content operation scales to a team where Tomas can lead strategy and automation while someone else handles daily video and design production.",
      "You value his AI sophistication and systems thinking as capabilities that will become more important as the brands grow and the content operation matures.",
      "You're looking for someone with an entrepreneurial, partner-level mindset who can think at the business level, not just the content level.",
    ],
 
    when_to_be_cautious: [
      "The immediate priority is a single person who produces visual content daily across TikTok, Instagram, and YouTube Shorts.",
      "DTC physical product brand content experience is a strong preference for the first hire.",
      "The three-metric framework needs to be the candidate's natural operating language from the start.",
      "Founder coaching and on-camera direction are core responsibilities that require hands-on production experience.",
    ],
 
    bottom_line:
      "Tomas is the #4 candidate in this group. His AI automation capability is the strongest by a clear margin, his strategic intelligence is genuine, and his entrepreneurial background shows real ownership mindset. Most of his experience has been in B2B environments, so the DTC social content production side of this role would be a transition. He's the kind of person whose value increases as the operation scales and the need for automation and content systems grows. For the role as it's scoped today, the other candidates are a closer fit for the daily execution requirements, but Tomas brings a unique skill set that's worth keeping in mind as the content operation evolves.",
  };


  // Score pill helper
  const ScorePill = ({ score }) => {
    let bg = "#f97316";
    if (score >= 8) bg = "#22c55e";
    else if (score >= 6) bg = "#36D1FF";
    return (
      <span
        style={{ backgroundColor: bg }}
        className="inline-block text-white text-xs font-bold px-3 py-1 rounded-full"
      >
        {score} / 10
      </span>
    );
  };

  return (
    <div className="min-h-screen bg-[#01014C] text-white flex flex-col items-center py-10 px-4">

      {/* ===================== PAGE 1 ===================== */}
      <div className="w-full max-w-6xl bg-[#FFFDFB] rounded-3xl overflow-hidden shadow-2xl flex flex-col md:flex-row relative">

        {/* LEFT COLUMN */}
        <aside className="relative md:w-1/3 bg-gradient-to-b from-[#01014C] via-[#0A0A80] to-[#36D1FF] p-8 flex flex-col items-center text-center overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-[#36D1FF]/30 to-transparent"></div>

          {/* Avatar */}
          <div className="relative mb-4">
            <div className="absolute inset-0 rounded-full bg-[#36D1FF]/20 blur-2xl"></div>
            <img
              src={JuanEstebanPhoto}
              alt={candidateProfileCopy.name}
              className="relative w-36 h-36 rounded-full object-cover border-4 border-[#36D1FF] shadow-lg"
            />
          </div>

          {/* Name */}
          <h1 className="text-2xl font-semibold mb-1 text-[#FFFDFB]">
            {candidateProfileCopy.name}
          </h1>

          {/* Location */}
          <div className="flex items-center gap-2 text-[#E0F7FF] text-sm mb-6 opacity-90">
            <FiMapPin className="text-[#36D1FF]" />
            <span>{candidateProfileCopy.location}</span>
          </div>

          {/* Compensation */}
          <div className="bg-[#01014C] border border-[#36D1FF]/50 rounded-xl p-4 w-full text-left mb-4">
            <p className="text-[#B3E9FF] text-sm font-semibold uppercase mb-1">
              Compensation
            </p>
            <p className="text-[#36D1FF] text-lg font-bold">
              {candidateProfileCopy.compensation.range}
            </p>
          </div>

          {/* Availability */}
          <div className="bg-[#01014C] border border-[#36D1FF]/30 rounded-xl p-4 w-full text-left mb-6">
            <p className="text-[#E0F7FF] text-sm">
              {candidateProfileCopy.availability}
            </p>
          </div>

          {/* Video Intro */}
          {candidateProfileCopy.loom_video_link && (
            <div className="w-full mt-4">
              <a
                href={candidateProfileCopy.loom_video_link}
                target="_blank"
                rel="noreferrer"
                className="block w-full text-center font-semibold py-3 rounded-lg
                           bg-[#36D1FF] text-[#01014C]
                           hover:bg-[#5FE2FF]
                           transition-all duration-300"
              >
                🎥 Watch Interview
              </a>
            </div>
          )}


          {/* Tools */}
          <div className="w-full mt-8 mb-6 text-left">
            <h3 className="text-sm font-semibold mb-3 text-[#B3E9FF] uppercase">
              Tools
            </h3>
            {candidateProfileCopy.tools.map((group, i) => (
              <div key={i} className="mb-4">
                <p className="text-xs font-semibold text-[#36D1FF] mb-1 uppercase tracking-wide">
                  {group.category}
                </p>
                <ul className="space-y-1">
                  {group.items.map((tool, j) => (
                    <li
                      key={j}
                      className="flex items-start gap-2 text-xs text-[#E0F7FF]/90 leading-snug"
                    >
                      <span className="mt-1 w-1.5 h-1.5 rounded-full bg-[#36D1FF] shrink-0" />
                      {tool}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Soft Skills */}
          <div className="w-full mb-6 text-left">
            <h3 className="text-sm font-semibold mb-2 text-[#B3E9FF] uppercase">
              Soft Skills
            </h3>
            <ul className="list-disc pl-5 space-y-1 text-[#E0F7FF] text-sm">
              {candidateProfileCopy.soft_skills.map((skill, i) => (
                <li key={i}>{skill}</li>
              ))}
            </ul>
          </div>

          {/* Logo */}
          <div className="w-full mt-8 flex justify-center">
            <img src={Logo} alt="AI-Architechs Logo" className="w-42 opacity-80" />
          </div>
        </aside>

        {/* RIGHT COLUMN */}
        <main className="flex-1 p-10 text-[#01014C] space-y-10">
          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              About this Candidate
            </h2>
            <p className="text-gray-700 leading-relaxed whitespace-pre-line">
              {candidateProfileCopy.about_candidate}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              Core Strengths
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              {candidateProfileCopy.core_strengths.map((item, i) => (
                <div key={i} className="border border-[#36D1FF]/30 rounded-xl p-5">
                  <p className="font-semibold mb-1">{item.headline}</p>
                  <p className="text-sm text-gray-700">{item.description}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              Relevant Experience
            </h2>
            <div className="space-y-6">
              {candidateProfileCopy.relevant_experience.map((exp, i) => (
                <div key={i} className="border border-[#36D1FF]/30 rounded-xl p-5">
                  <p className="font-semibold text-[#EB5D2A] mb-2">{exp.headline}</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm text-gray-700">
                    {exp.bullets.map((b, j) => (
                      <li key={j}>{b}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </section>
        </main>
      </div>

      {/* ===================== PAGE BREAK BAND ===================== */}
      <div className="w-full py-10">
        <div className="max-w-6xl mx-auto px-4">
          <div className="h-10 rounded-2xl bg-gradient-to-r from-[#01014C] via-[#0A0A80] to-[#36D1FF] opacity-70 shadow-[0_0_40px_#36D1FF20]" />
        </div>
      </div>

      {/* ===================== PAGE 2 ===================== */}
      <div className="w-full max-w-6xl bg-[#FFFDFB] rounded-3xl overflow-hidden shadow-2xl pb-2">
        <main className="p-10 text-[#01014C]">
          <div className="border border-[#36D1FF]/25 rounded-2xl p-6 bg-white shadow-[0_0_12px_#36D1FF15]">

            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-2 mb-6">
              <h2 className="text-2xl font-semibold text-[#01014C]">
                Technical Analysis
              </h2>
              <div className="flex flex-col items-start md:items-end gap-1 text-xs text-gray-400">
                <span>{technicalAssessment.meta.role}</span>
                <span>Interview: {technicalAssessment.meta.interviewDate}</span>
                <span>{technicalAssessment.meta.analyst}</span>
              </div>
            </div>

            {/* Snapshot */}
            <div className="border border-[#36D1FF]/20 rounded-xl p-5 bg-[#36D1FF]/5 mb-6">
              <p className="text-base font-bold text-[#01014C] mb-2">Executive Fit Snapshot</p>
              <p className="text-gray-700 text-base leading-relaxed whitespace-pre-line">
                {technicalAssessment.snapshot}
              </p>
            </div>

            {/* Strengths & Flags */}
            <div className="grid md:grid-cols-2 gap-6 mb-6">

              {/* Strengths */}
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ✅ Strengths
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.strengths.map((item, i) => (
                    <div
                      key={i}
                      className="border border-[#22c55e]/30 rounded-xl p-4 bg-[#22c55e]/5"
                    >
                      <p className="font-semibold text-sm text-[#01014C] mb-1">
                        {item.headline}
                      </p>
                      <p className="text-sm text-gray-700">{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Flags */}
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ⚠️ Flags / Watch-outs
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.flags.map((item, i) => (
                    <div
                      key={i}
                      className="border border-[#f97316]/30 rounded-xl p-4 bg-[#f97316]/5"
                    >
                      <p className="font-semibold text-sm text-[#01014C] mb-1">
                        {item.headline}
                      </p>
                      <p className="text-sm text-gray-700">{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Scorecard */}
            <div className="mb-6">
              <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                Quantitative Scorecard
              </h3>
              <div className="overflow-x-auto rounded-xl border border-[#36D1FF]/25">
                <table className="w-full text-sm">
                  <thead className="bg-[#36D1FF]/10 text-[#01014C]">
                    <tr>
                      <th className="text-left font-semibold px-4 py-3">Dimension</th>
                      <th className="text-left font-semibold px-4 py-3 w-[120px]">Score</th>
                      <th className="text-left font-semibold px-4 py-3">Rationale</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#36D1FF]/15">
                    {technicalAssessment.scorecard.map((row, idx) => (
                      <tr key={idx} className="bg-white">
                        <td className="px-4 py-3 font-medium text-[#01014C] align-top">
                          {row.dimension}
                        </td>
                        <td className="px-4 py-3 align-top">
                          <ScorePill score={row.score} />
                        </td>
                        <td className="px-4 py-3 text-gray-700 whitespace-pre-line align-top">
                          {row.rationale}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* When to Hire / Considerations */}
            <div className="grid md:grid-cols-2 gap-6 mb-6">

              {/* When to Hire */}
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ✅ Hire Juan Esteban if…
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.when_to_hire.map((item, i) => (
                    <div
                      key={i}
                      className="border border-[#36D1FF]/30 rounded-xl p-4 bg-[#36D1FF]/5 text-sm text-gray-700"
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* When to Be Cautious */}
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ⚠️ Be cautious or pass if…
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.when_to_be_cautious.map((item, i) => (
                    <div
                      key={i}
                      className="border border-[#f59e0b]/30 rounded-xl p-4 bg-[#f59e0b]/5 text-sm text-gray-700"
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Bottom Line */}
            <div className="border border-[#01014C]/20 rounded-xl p-5 bg-[#01014C]/5">
              <p className="text-sm font-bold text-[#01014C] mb-2 uppercase tracking-wide">
                🏁 Bottom Line
              </p>
              <p className="text-gray-700 text-sm leading-relaxed">
                {technicalAssessment.bottom_line}
              </p>
            </div>

          </div>
        </main>
      </div>

    </div>
  );
}
